// extracted by mini-css-extract-plugin
export default {"divSeparator":"styles_divSeparator__9GsA0","floorSection":"styles_floorSection__6mDy2"};